import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Settings.css";
import api from "../services/api";

const Settings = () => {
  const navigate = useNavigate();

  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {

      const response = await api.post("/setting_detail.php", {});

      if (response.data.head.code === 200) {
        // Transform the data


        setSettings(response.data.body);
      } else if (response.data.head.code === 606) {
        // No purchases found - set empty array
        setSettings([]);
      } else {
        // setError(response.data.head.msg || "Failed to fetch purchases");
      }
    } catch (err) {
      console.error("Error fetching purchases:", err);
      // setError("Failed to load purchases. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    // Here you would typically make an API call to save the settings

    const payload = {
      mobile: settings.mobile,
      address: settings.address,
      password: settings.password,
      gst: settings.gst_no,
      state: settings.state,
      city: settings.city,
      packing_charge: settings.packing_charge,
      pincode: settings.pincode
    };
    console.log("Saving settings:", payload);
    /*  */
    const response = await api.post("/settings_update.php", payload);

    if (response.data.head.code === 200) {
      alert("Settings updated successfully!");
      window.location.reload();
    }

  };

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">Settings</h2>

      <div className="customer-header d-flex justify-content-between align-items-center mb-3">
        <div></div>
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label="Company Settings">
              <tbody>
                {/* <tr>
                  <td className="field-cell">Email</td>
                  <td className="value-cell">
                    <input
                      type="email"
                      value={settings.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr> */}

                <tr>
                  <td className="field-cell">Phone number</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.mobile}
                      onChange={(e) => handleChange("mobile", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">Address</td>
                  <td className="value-cell">
                    <textarea
                      value={settings.address}
                      onChange={(e) => handleChange("address", e.target.value)}
                      className="settings-input settings-textarea"
                      rows="3"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">GST Number</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.gst_no}
                      onChange={(e) => handleChange("gst_no", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">City</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.city}
                      onChange={(e) => handleChange("city", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">State</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.state}
                      onChange={(e) => handleChange("state", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">Pincode</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      maxLength={6}
                      value={settings.pincode}
                      onChange={(e) => handleChange("pincode", e.target.value.replace(/\D/g, ""))}
                      className="settings-input"
                    />
                  </td>
                </tr>

                {/* <tr>
                  <td className="field-cell">Packing Charge (%)</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.packing_charge}
                      onChange={(e) => handleChange("packing_charge", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr> */}

                <tr>
                  <td className="field-cell">Password</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.password}
                      onChange={(e) => handleChange("password", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                {/* <tr>
                  <td className="field-cell">CGST (%)</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.cgst}
                      onChange={(e) => handleChange("cgst", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">SGST (%)</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.sgst}
                      onChange={(e) => handleChange("sgst", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">Bank Name</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.bankName}
                      onChange={(e) => handleChange("bankName", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">A/C Holder Name</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.accountHolderName}
                      onChange={(e) => handleChange("accountHolderName", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">A/C Number</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.accountNumber}
                      onChange={(e) => handleChange("accountNumber", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr>

                <tr>
                  <td className="field-cell">IFSC Code</td>
                  <td className="value-cell">
                    <input
                      type="text"
                      value={settings.ifscCode}
                      onChange={(e) => handleChange("ifscCode", e.target.value)}
                      className="settings-input"
                    />
                  </td>
                </tr> */}
              </tbody>
            </table>

            {/* Commit Changes Button */}
            <div className="settings-actions mt-4">
              <Button variant="success" onClick={handleSave} className="commit-btn">
                Commit Changes
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Settings;